import React from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "@/components/MarketingLayout";
import { SCHEME_LIST } from "@/lib/schemes";
import { ArrowRight } from "lucide-react";

export default function Schemes() {
  return (
    <MarketingLayout>
      <section className="hero-radial grain">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
          <div className="text-sm text-slate-500 mb-4"><Link to="/" className="hover:text-emerald-700">Home</Link> / Schemes</div>
          <h1 className="font-head font-extrabold text-3xl sm:text-4xl lg:text-5xl text-emerald-950 tracking-tight">Government Schemes We Help With</h1>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl">We prepare and submit applications for these central & state benefit schemes. Pick one to see details and apply.</p>
        </div>
      </section>
      <section className="pb-20 -mt-6">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SCHEME_LIST.map((s) => (
            <Link key={s.code} to={`/scheme/${s.code}`} data-testid={`scheme-link-${s.code}`} className="group bg-white rounded-3xl p-7 border border-emerald-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
              <div className="h-14 w-14 rounded-2xl grid place-items-center" style={{ backgroundColor: s.tint }}>
                <s.icon className="h-7 w-7" style={{ color: s.color }} />
              </div>
              <div className="mt-4 text-xs font-mono font-semibold text-slate-400">{s.code}</div>
              <h3 className="mt-1 font-head font-bold text-lg text-emerald-950 leading-snug">{s.name}</h3>
              <p className="mt-2 text-sm text-slate-500">{s.short}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-emerald-700 font-semibold text-sm group-hover:gap-2.5 transition-all">View & Apply <ArrowRight className="h-4 w-4" /></span>
            </Link>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
